import React, { useEffect, useState } from "react";
import { signInAnonymously } from "firebase/auth";
import { auth } from "../../config/firebase";
import Center from "../utils/Center";
import CircularProgress from "../../tailwind/components/CircularProgress";

interface Props {
  children: React.ReactNode;
}

const AuthChecker = ({ children }: Props) => {
  const [ready, setReady] = useState(!!auth.currentUser);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (auth.currentUser) {
      setReady(true);
      return;
    }

    signInAnonymously(auth)
      .then(() => setReady(true))
      .catch((error) => {
        console.error("Anonymous sign-in failed:", error);
        setFailed(true);
      });
  }, []);

  if (failed) {
    return (
      <Center>
        <p className="text-gray-600 text-sm">
          Something went wrong loading this page. Please refresh and try again.
        </p>
      </Center>
    );
  }

  if (!ready) {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  }

  return <>{children}</>;
};

export default AuthChecker;      
